/**
 * Removes unnecessary trailing zeros after the decimal point
 * @param value - The number value to clean (can be string or number)
 * @returns Cleaned string with trailing zeros removed
 *
 * Examples:
 * - removeTrailZero(11.50) => "11.5"
 * - removeTrailZero(12.00) => "12"
 * - removeTrailZero(12.25) => "12.25"
 * - removeTrailZero("11.50") => "11.5"
 */
export const removeTrailZero = (value: string | number): string => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  // Convert to number first to handle string inputs
  const numValue = typeof value === "string" ? parseFloat(value) : value;

  // Check if it's a valid number
  if (isNaN(numValue)) {
    return "";
  }

  // Convert to string and remove trailing zeros
  // This will automatically handle the formatting
  return numValue.toString();
};

/**
 * Formats a number input value on blur to remove trailing zeros
 * This is meant to be used as an onBlur handler for input fields
 */
export const formatNumberOnBlur = (
  value: string | number,
  onChange: (value: string) => void
): void => {
  const formatted = removeTrailZero(value);
  if (formatted !== value?.toString()) {
    onChange(formatted);
  }
};
